import { render, staticRenderFns } from "./BaseQuotationStatus.vue?vue&type=template&id=73556736"
import script from "./BaseQuotationStatus.vue?vue&type=script&lang=js"
export * from "./BaseQuotationStatus.vue?vue&type=script&lang=js"
import style0 from "./BaseQuotationStatus.vue?vue&type=style&index=0&id=73556736&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports